export default __webpack_public_path__ + "static/4-7807395665a9b9a0304d57815caef8fa.webp";